import React from 'react'
import './Wwo.css'
import CountUpOnScroll from '../../Home/About/ScrollCounter'
import cs from '../../../../assets/img/globe.svg'
import pd from '../../../../assets/img/project_delivered.svg'
import te from '../../../../assets/img/te.svg'
import yoe from '../../../../assets/img/yoe.svg'
import cwad from '../../../../assets/img/cwad.svg'
import ecde from '../../../../assets/img/ecde.svg'
import swad from '../../../../assets/img/swad.svg'
import pwa from '../../../../assets/img/pwa.svg'
import wasm from '../../../../assets/img/wasm.svg'

function Wwo() {

  const wwolist = [
    {
      icon:cwad,
      title: "Idea and Requirements Gathering",
      desc: "We start by mapping your current processes, pain points, and success metrics. This ensures the solution we build addresses real problems and drives measurable value."
    },
    {
      icon:ecde,
      title: "Solution Architecture and Roadmap",
      desc: "Our architects design a scalable, secure architecture and a phased roadmap that aligns with your budget and timeline."
    },
    {
      icon:swad,
      title: "Design and Development",
      desc: "We follow user-centric design and modular engineering to create intuitive, maintainable systems. Regular demos and sprint reviews keep stakeholders aligned and informed."
    },
    {
      icon:pwa,
      title: "Quality Assurance and Security Testing",
      desc: "Robust testing at unit, integration, and system levels ensures reliability. Security checks and compliance reviews are embedded into our process."
    },
    {
      icon:wasm,
      title: "Deployment and Post-Launch Support",
      desc: "We manage deployment, run post-launch monitoring, and provide proactive maintenance and enhancements to keep your system running optimally."
    },
    
  ]

  return (
    <section className='wwo-sec'>
        <div className='container'>
            <div className='pht-sec'>
                <ul>
                    <li><img src={cs} alt='' loading="lazy"/><h4> <CountUpOnScroll end={25} />+</h4><p>Countries Served</p></li>
                    <li><img src={pd} alt='' loading="lazy"/><h4> <CountUpOnScroll end={200} />+</h4><p>Projects Delivered</p></li>
                    <li><img src={te} alt='' loading="lazy"/><h4> <CountUpOnScroll end={120} />+</h4><p>Tech Enthusiast</p></li>
                    <li><img src={yoe} alt='' loading="lazy"/><h4> <CountUpOnScroll end={10} />+</h4><p>Years of Experience</p></li>
                </ul>
            </div>
            <div className='wwo-sec1'>
            <h3>How We Deliver</h3>
              <ul>
                {
                  wwolist.map((Wwo, index)=>(
                    <li key={index}>
                      <div className='wwo-icon'><img src={Wwo.icon} alt=''/></div>
                      <h4>{Wwo.title}</h4> 
                      <p>{Wwo.desc}</p>  
                    </li>
                  ))
                }
                   
              </ul>    
            </div> 
        </div>
    </section>
  )
}

export default Wwo
